exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".help__page__container {\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n\n.help__nav__bar {\n  display: flex;\n  padding: 16px 24px;\n  min-height: 64px;\n  align-items: center;\n  flex-direction: column;\n  background-color: #000;\n  justify-content: center;\n  width: 100%; }\n\n.help__page__content {\n  padding: 40px;\n  max-width: 1200px;\n  width: 100%;\n  display: flex;\n  justify-content: center; }\n\n.help__logo {\n  filter: invert(1); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Help/index.scss
// module id = 6527
// module chunks = 1